import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: "block",
    },
  }),
  { name: "image-chooser-style", flip: null }
);
